<template>
  <div>
    <LDBsTable
      url="arena/positions-vw-vdata"
      defaultSort="id"
      defaultOrder="asc"
      :query="queryToUse"
      :columns="columns"
      :clear="clear"
      :defaultOptions="options"
      :loadOnMount="false"
      :startSearchOpen="true"
      :disableSearch="canSearch"
    >
      <div class="col-lg-12 text-center">
        <p>
          <span class="label label-danger">É obrigatório informar um VEÍCULO e um intervalo de DATA ATÉ 30 DIAS</span>
        </p>
      </div>

      <div class="form-group col-lg-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :initial-value="query.companyId"
          label="CLI_DSC"
          v-model="query.companyId"
          :reduce="(client) => client.CLI_ID"
        />
      </div>

      <div class="form-group col-lg-12">
        <label for="speed">{{ $t("speed") }}</label>
        <input
          type="text"
          id="ionrange_1"
          v-model="query.speed"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="board">{{ $t("board") }}</label>
        <input
          type="text"
          id="board"
          name="board"
          class="form-control"
          :placeholder="$t('ph_board')"
          v-model="query.vehiclePlate"
          @input="upper('vehiclePlate')"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="datetime_start">{{ $t("datetime_start") }}</label>
        <input
          type="datetime-local"
          id="datetime_start"
          name="datetime_start"
          class="form-control"
          :placeholder="$t('ph_datetime_start')"
          v-model="query.datetimeStart"
          step="1"
        />
      </div>

      <div class="form-group col-lg-4">
        <label for="datetime_end">{{ $t("datetime_end") }}</label>
        <input
          type="datetime-local"
          id="datetime_end"
          name="datetime_end"
          class="form-control"
          :placeholder="$t('ph_datetime_end')"
          v-model="query.datetimeEnd"
          step="1"
        />
      </div>
    </LDBsTable>

    <!-- MODAL CONFIRM REMOVE POSITION -->
    <div
      class="modal fade"
      id="modalConfirmRemovePosition"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalConfirmRemovePositionLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalConfirmRemovePositionLabel">
              Deseja remover este posicionamento?
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <ul>
              <li>
                PLACA: <strong>{{ dataToRemove.plate }}</strong>
              </li>
              <li>
                DATA/HORA: <strong>{{ formatDate(dataToRemove.datetime) }}</strong>
              </li>
              <li>
                VELOCIDADE: <strong>{{ dataToRemove.speed }}</strong>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              {{ $t("close") }}
            </button>

            <LoaderButton
              class="mt-3"
              @click="removePosition"
              :loading="isLoading"
            >
              {{ $t("confirm") }}
            </LoaderButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LDBsTable from "@/components/shared/LDBsTable";
import Combobox from "@/components/shared/ComboBox";
import { mapState } from "vuex";
import moment from "moment";
import LoaderButton from '@/components/button/LoaderButton'

export default {
  name: "ArenaVehicleTypeList",

  components: {
    LDBsTable,
    Combobox,
    LoaderButton
  },

  data() {
    return {
      columns: [
        {
          title: this.$t("client"),
          field: "companyId",
          sortable: true,
          formatter: (value) => {
            return this.clientsById[value] || "-";
          },
          visible: false
        },
        {
          title: this.$t("vehicle"),
          field: "vehicleDescription",
          sortable: true,
          formatter: (value, row) => {
            const { vehicleId, vehiclePlate } = row

            const values = [vehicleId, value, vehiclePlate]

            return values.join(" / ") || "-";
          },
        },
        {
          title: this.$t("datetime"),
          field: "datetime",
          sortable: true,
          formatter: (value) => {
            return value ? new Date(value).toLocaleString() : "-";
          },
        },
        {
          title: this.$t("lat/lon"),
          field: "latitude",
          formatter: (value, row) => {
            const { longitude } = row

            const values = [value, longitude]

            return values.join(",") || "-";
          }
        },
        {
          title: this.$t("point"),
          field: "pointDescription",
          sortable: true,
          formatter: (value, row) => {
            const { pointId } = row

            const values = [pointId, value]

            return values.join(" / ") || "-";
          },
          visible: false
        },
        {
          title: this.$t("hourmeter"),
          field: "hourmeter",
        },
        {
          title: this.$t("odometer"),
          field: "odometer",
        },
        {
          title: this.$t("speed"),
          field: "speed",
          formatter: value => {
            const speedRounded = Math.round(value)

            return `${speedRounded} km/h`
          },
          sortable: true
        },
        {
          title: this.$t("ignition"),
          field: "ignition",
          formatter: (value) => {
            return value ? 'SIM' : 'NÃO';
          },
        },
        {
          title: this.$t("GPS"),
          field: "gps",
          formatter: (value) => {
            return value ? 'SIM' : 'NÃO';
          },
        },
        {
          title: this.$t("GPRS"),
          field: "GPRS",
          formatter: (value) => {
            return value ? 'SIM' : 'NÃO';
          },
        },
        {
          title: this.$t("panic"),
          field: "panic",
          formatter: (value) => {
            return value ? 'SIM' : 'NÃO';
          },
        },
        {
          title: this.$t("in2"),
          field: "in2",
          formatter: (value) => {
            return value ? 'SIM' : 'NÃO';
          },
        },
        {
          title: this.$t("in3"),
          field: "in3",
          formatter: (value) => {
            return value ? 'SIM' : 'NÃO';
          },
        },
        {
          title: this.$t("voltage"),
          field: "voltage",
        },
        {
          title: this.$t("reason"),
          field: "reason",
          visible: false
        },
        {
          title: this.$t("temperature"),
          field: "temperature",
          visible: false
        },
        {
          key: "id",
          field: "id",
          align: "center",
          width: "100%",
          formatter: function (value, row) {
            return `
              <button
                title="Desativar usuário"
                data-target="#modalConfirmRemovePosition"
                data-id='${value}'
                data-plate='${row.vehiclePlate}'
                data-vehicle='${row.vehicleId}'
                data-datetime='${row.datetime}'
                data-speed='${row.speed}'
                data-toggle="modal"
                class="edit mb-1 btn btn-action btn-sm btn-danger btn-circle light-bottom-shadow text-white"
              >
                <i class="fas fa-trash" />
              </button>
            `;
          },
        },
      ],
      options: {
        exportOptions: { fileName: "arena_limpar_posicionamentos" },
      },
      queryToUse: {},
      query: {
        companyId: "",
        datetimeStart: "",
        datetimeEnd: "",
        vehiclePlate: "",
        speed: '0;1000',
      },
      clientsById: {},
      dataToRemove: {}
    };
  },

  computed: {
    ...mapState({
      lastquery: (state) => state.filtershistory.query,
      clients: state => state.arena.clients,
      isLoading: state => state.arena.isLoading,
    }),

    canSearch() {
      const { vehiclePlate, datetimeStart, datetimeEnd } = this.query

      const propertiesOk = [vehiclePlate, datetimeStart, datetimeEnd].every(Boolean)

      if (!propertiesOk) {
        return true
      }

      const dateMomentStart = moment(datetimeStart)
      const dateMomentEnd = moment(datetimeEnd)

      if (dateMomentEnd.isBefore(dateMomentStart)) {
        return true
      }

      const diffDays = Math.abs(dateMomentEnd.diff(dateMomentStart, 'days'));

      return diffDays > 30
    }
  },

  methods: {
    clear() {
      this.query.companyId = "";
      this.query.vehiclePlate = "";
      this.query.speed = "0;1000";

      this.setDefaultDatetime()
    },

    upper(attr) {
      this.query[attr] = this.query[attr].toUpperCase();
    },

    setDefaultDatetime() {
      this.query.datetimeStart = moment().format("YYYY-MM-DD 00:00:00");
      this.query.datetimeEnd = moment().format("YYYY-MM-DD 23:59:59")
    },

    async removePosition() {
      const { vehicleId, datetime } = this.dataToRemove

      await this.$store.dispatch(
        'arena/removePositionDadoLido',
        {
          VEI_ID: vehicleId,
          DDL_DH: datetime
        }
      )

      $("#modalConfirmRemovePosition").modal("hide");
      $("#search").trigger("click");
    },

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss')
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery["cleanposition"]
      ? this.lastquery["cleanposition"]
      : this.query;
  },

  async mounted() {
    await this.$store.dispatch('arena/fetchClients')

    if (this.lastquery["cleanposition"]) {
      for (const [key, value] of Object.entries(
        this.lastquery["cleanposition"]
      )) {
        this.query[key] = value;
      }
    }

    this.queryToUse = this.query;

    this.clientsById = this.clients.reduce((acc, client) => {
      acc[client.CLI_ID] = client.CLI_DSC;

      return acc;
    }, {});

    $("#ionrange_1").ionRangeSlider({
      min: 0,
      max: 1000,
      type: 'double',
      prefix: "",
      maxPostfix: "+",
      prettify: false,
      hasGrid: true,
      onFinish: (data) => {
        this.query.speed = `${data.from};${data.to}`
      }
    });

    const global = this

    $("#modalConfirmRemovePosition").on("show.bs.modal", function (event) {
      const button = $(event.relatedTarget);

      global.dataToRemove = {
        plate: button.data("plate"),
        vehicleId: button.data("vehicle"),
        datetime: button.data("datetime"),
        speed: button.data("speed"),
      }
    });

    $("#modalConfirmRemovePosition").on("hide.bs.modal", function (event) {
      global.dataToRemove = {}
    });
  },

  destroyed() {
    this.$store.dispatch("filtershistory/setQuery", {
      key: "cleanposition",
      query: this.query,
    });
  },
};
</script>
